// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: false,

	firebase: {
		apiKey: 'AIzaSyAeIJAVb_oFo-HAVmQrM9_-MdsyjHi-BjA',
		authDomain: 'ecim-dev.firebaseapp.com',
		databaseURL: 'https://ecim-dev.firebaseio.com',
		projectId: 'ecim-dev',
		storageBucket: 'ecim-dev.appspot.com',
		messagingSenderId: '296808783807'
	},

	functions: {
		baseUrl: 'https://us-central1-ecim-dev.cloudfunctions.net'
	}
};



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/environments/environment.ts